<template>
  <nav
    class="navbar navbar-expand-md navbar-light bg-white pt-3 pb-3 border-bottom shadow-sm"
  >
    <router-link to="/" class>
      <img class="logo" alt="logo" src="../assets/img/logo2.png" />
    </router-link>
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarCollapse"
      aria-controls="navbarCollapse"
      aria-expanded="false"
      aria-label="Toggle navigation"
      @click="handleShow"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div
      class="collapse  navbar-collapse  justify-content-end"
      :class="[{collapseHidden:showMenu=== false}, {collapseShow:showMenu=== true}]" 
      id="navbarCollapse"
    >
      <ul class="navbar-nav topNav">
        <li class="nav-item active">
          <router-link class="nav-link" to="/?active=0"
            >国际范式与研究方法</router-link
          >
        </li>
        <li class="nav-item active">
          <router-link class="nav-link" to="/?active=1"
            >学术前沿与经典理论</router-link
          >
        </li>
        <li class="nav-item active">
          <router-link class="nav-link" to="/?active=2"
            >选题与科研立项</router-link
          >
        </li>
        <li class="nav-item active">
          <router-link class="nav-link" to="/?active=3"
            >学术写作与出版</router-link
          >
        </li>
        <li class="nav-item active">
          <router-link class="nav-link" to="/?active=4">图书资源</router-link>
        </li>
        <!-- <div class="search2 mt-1" style="display:inline-block">
          <div>
            <input type="text" placeholder required />
          </div>
        </div> -->
      </ul>
    </div>
  </nav>
</template>
<script>
  export default {
    data() {
      return {
        showMenu: false
      }
    },
    methods: {
      handleShow() {
        this.showMenu = !this.showMenu
        console.log(this.showMenu)
      }
    }
  }
</script>
<style>
@import url("../assets/style.css");
@import url("../assets/bootstrap.css");
</style>
